import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { getScreens } from 'services/screen-service'

import View from './view'

const DebugBar = ({ debugBool, screenSelectedState, contentAttributes, isPassiveMode, countDown, zone }) => {
  const [screenSelected, setScreenSelected] = screenSelectedState
  const [screens, setScreens] = useState([])

  const handleScreenChange = value => {
    if (screenSelected && value.value === screenSelected.value) {
      return
    }

    setScreenSelected(value)
    localStorage.setItem('screenWeb', JSON.stringify(value))
  }

  useEffect(() => {
    getScreens().then(response => {
      const options = []
      response.data.data.forEach(screen => {
        options.push({ value: screen.screenId, label: screen.name })
        setScreens(options)
      })
    })
  }, [])

  return (
    <View
      debugBool={debugBool}
      screens={screens}
      screenSelected={screenSelected}
      onScreenChange={handleScreenChange}
      contentAttributes={contentAttributes}
      isPassiveMode={isPassiveMode}
      countDown={countDown}
      zone={zone}
    />
  )
}

DebugBar.defaultProps = {
  debugBool: false,
  contentAttributes: {},
  zone: null,
}

DebugBar.propTypes = {
  debugBool: PropTypes.bool,
  screenSelectedState: PropTypes.array,
  contentAttributes: PropTypes.object,
  isPassiveMode: PropTypes.bool.isRequired,
  countDown: PropTypes.number.isRequired,
  zone: PropTypes.number,
}

export default DebugBar
